import { useEffect, useState } from "react";

import { Box, Button } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import { ApiEndpoint } from "@constants/index";
import DeleteButton from "common/DeleteButton";
import { SortableItem } from "react-easy-sort";
import { IIngredient } from "@modules/ingredient/types";
import { useLazyGetIngredientsQuery, useDeleteIngredientMutation } from "@modules/ingredient";

import { StyledImg } from "./styled";

const Ingredients = () => {
  const [ingredients, setIngredients] = useState<IIngredient[]>([])
  const [getIngredients] = useLazyGetIngredientsQuery()
  const [deleteIngredient] = useDeleteIngredientMutation()

  const handleGetRequest = async () => {
    try {
      const ingredientsResponse = await getIngredients({ offset: 0, limit: 100 }).unwrap();

      setIngredients(ingredientsResponse?.ingredients || [])
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteIngredient = async (id: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteIngredient({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleGetRequest()
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <Link to={PRIVATE_PAGES.CREATE_INGREDIENTS}>
        <Button variant="contained" color="primary">
          Create Ingredient
        </Button>
      </Link>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr 1fr',
              }}
            >
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Visible</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {ingredients.map(({
              id,
              name,
              visible,
              images,
            }) => {
              return (
                <TableRow
                  key={id}
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  }}
                >
                  <TableCell align="center">
                    {images?.[0]?.url && <StyledImg src={`${ApiEndpoint}/${images[0].url}`} alt="" />}
                  </TableCell>
                  <TableCell align="center">{name}</TableCell>
                  <TableCell align="center">{visible ? 'Yes' : 'No'}</TableCell>
                  <TableCell align="center">
                    <Link to={`/ingredient/${id}`}>
                      <Button variant="outlined">
                        Edit
                      </Button>
                    </Link>
                    <DeleteButton
                      callBack={() => {
                        handleDeleteIngredient(id)
                      }}
                    />
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
};

export default Ingredients;
